import { getAccountTypeDropdownList } from "@/redux/features/accountType/accountTypeSlice";
import { Package, Ship, Truck } from "lucide-react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const iconMap = {
  1: Package,
  2: Ship,
  3: Truck,
};

const colorMap = {
  1: "from-blue-500 to-blue-600",
  2: "from-teal-500 to-teal-600",
  3: "from-purple-500 to-purple-600",
};

const descriptionMap = {
  1: "Shipper or consignee who owns the cargo",
  2: "Non-Vessel Operating Common Carrier",
  3: "Logistics service provider",
};

export default function CompanyTypePicker({
  onSelect,
  title = "Select Company Type",
  subtitle = "Configure navigation visibility per role for the selected company type.",
  className = "",
}) {
  const dispatch = useDispatch();
  const accountTypes = useSelector((state) => state.accountType.accountTypes);

  const companyTypes =
    accountTypes?.map((item) => ({
      id: String(item.VALUE),
      name: item.TEXT,
      description: descriptionMap[item.VALUE] || "",
      icon: iconMap[item.VALUE] || Package,
      color: colorMap[item.VALUE] || "from-slate-500 to-slate-600",
    })) || [];

  useEffect(() => {
    if (!accountTypes?.length) {
      dispatch(getAccountTypeDropdownList());
    }
  }, [dispatch, accountTypes?.length]);

  return (
    <div className={`space-y-5 ${className}`}>
      <div>
        <h2 className="text-base font-semibold text-slate-900 dark:text-white">
          {title}
        </h2>

        {subtitle && (
          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">
            {subtitle}
          </p>
        )}
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {companyTypes.map((type) => {
          const Icon = type.icon;

          return (
            <button
              key={type.id}
              onClick={() => onSelect?.(type.id)}
              className="
                group text-left
                rounded-xl border border-slate-200 dark:border-slate-700
                bg-white dark:bg-slate-800
                p-4 hover:border-teal-400 dark:hover:border-teal-600
                hover:shadow-sm transition-all duration-150
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500
              "
            >
              <div
                className={`
                  h-10 w-10 rounded-lg
                  bg-gradient-to-br ${type.color}
                  flex items-center justify-center mb-3
                `}
              >
                <Icon className="h-5 w-5 text-white" />
              </div>

              <div className="font-semibold text-sm text-slate-900 dark:text-white group-hover:text-teal-700 dark:group-hover:text-teal-400 transition-colors">
                {type.name}
              </div>

              <div className="text-xs text-slate-500 dark:text-slate-400 mt-1 leading-relaxed">
                {type.description}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
